import { Configs } from "./index";
import Web3 from "web3";

const INFOCHAIN = {
  DOS: {
    TOKEN_USDC: '0xF8C84F0CB9E21398d04D3B1bdB142baaF9Bcf2D7',
  },
  AVAX: {
    TOKEN_USDC: '0x5C085B06d6505231AbE1c9F5ab1195F8c6e80b2d',
  }
}

const configs: Configs = {
  CLIENT: 'testnet',
  API_URI: "",
  NETWORKS: {
    AVAX: {
      chainId: Web3.utils.numberToHex(43113),
      rpcUrls: ["https://api.avax-test.network/ext/C/rpc"],
      chainName: "Fuji (C-Chain)",
      blockExplorerUrls: ["https://testnet.snowtrace.io"],
      nativeCurrency: {
        name: "AVAX",
        symbol: "AVAX",
        decimals: 18,
      },
    },
    BSC: {
      chainId: Web3.utils.numberToHex(97),
      rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545"],
      chainName: "BSC Test Net",
      blockExplorerUrls: ["https://testnet.bscscan.com"],
      nativeCurrency: {
        name: "BNB",
        symbol: "BNB",
        decimals: 18,
      },
    },
    DOS: {
      chainId: Web3.utils.numberToHex(3939),
      rpcUrls: ["https://test.doschain.com"],
      chainName: "DOS",
      blockExplorerUrls: ["https://test.doscan.io"],
      nativeCurrency: {
        name: "DOS Test Net",
        symbol: "DOS",
        decimals: 18,
      },
    },

  },
  DEFAULT_CHAIN: "AVAX",

};
export default configs;


// ETH
// 0x12a15692584917291Cc5654e0E70CB7f9fb6cEc6 // nft
